import { observable, action, makeObservable } from "mobx";
import ApiBasedStore from "./ApiBasedStore";

export default class ShortenedLinksStore extends ApiBasedStore {
  urls = [];
  totalUrls = 0;
  currentPage = 1;
  pageSize = 20;
  isCreating = false;
  deletingUrls = new Set();
  searchQuery = "";

  constructor(rootStore, api) {
    super(rootStore);
    this.api = api;
    makeObservable(this, {
      urls: observable,
      totalUrls: observable,
      currentPage: observable,
      pageSize: observable,
      isCreating: observable,
      deletingUrls: observable,
      searchQuery: observable,
      fetchUrls: action,
      createShortUrl: action,
      deleteShortUrl: action,
      setCurrentPage: action,
      setSearchQuery: action,
    });
  }

  async fetchUrls(page = 1, pageSize = this.pageSize, search = this.searchQuery) {
    try {
      this.startRequest();
      const offset = (page - 1) * pageSize;
      const response = await this.api.getShortenedUrls(pageSize, offset, search);
      
      this.urls = response.urls || [];
      this.totalUrls = response.total || 0;
      this.currentPage = page;
      
      this.endRequest();
      return response;
    } catch (error) {
      this.onError(error);
      throw error;
    }
  }

  async createShortUrl(url) {
    try {
      this.isCreating = true;
      const response = await this.api.createShortUrl(url);
      this.isCreating = false;
      return response;
    } catch (error) {
      this.isCreating = false;
      throw error;
    }
  }

  async deleteShortUrl(shortCode) {
    try {
      this.deletingUrls.add(shortCode);
      const response = await this.api.deleteShortUrl(shortCode);
      this.deletingUrls.delete(shortCode);
      return response;
    } catch (error) {
      this.deletingUrls.delete(shortCode);
      throw error;
    }
  }

  setCurrentPage(page) {
    this.currentPage = page;
    this.fetchUrls(page);
  }

  setSearchQuery(query) {
    this.searchQuery = query;
    this.currentPage = 1; // Reset to first page when searching
    this.fetchUrls(1, this.pageSize, query);
  }

  get totalPages() {
    return Math.ceil(this.totalUrls / this.pageSize);
  }
}